export const menuSectionDefinitions = [
  {
    label: 'Overview',
    modules: new Set(['Dashboard']),
  },
  {
    label: 'Vendor Setup',
    modules: new Set([
      'Account', 'Account Locations', 'User', 'Location', 'Business Hours', 'Policies',
      'Tax', 'Optional Services', 'Optional Services Standard', 'Optional Services Images',
      'Fleet Description', 'Fleet Standard', 'Cars', 'One Way Rental', 'Reservation Source',
      'Rate Code', 'Account Rate Code', 'Account Rate Rules', 'Rate ID',
      'Affiliate OTA Mapping', 'Policy Expedia', 'MarkUp Info',
    ]),
  },
  {
    label: 'Rates & Inventory',
    modules: new Set([
      'Minimum Rate', 'Rate Update', 'Adjustment', 'Promotion', 'Blackout', 'Update Inventory',
      'Utilization Based Adjustment', 'Capacity Control', 'Rate Snapshot', 'Competitor Setup',
      'Minimum Rate Mapping', 'Currency Converter', 'View Base Rates', 'Ceiling Rate', 'Competitors',
    ]),
  },
  {
    label: 'Reservations',
    modules: new Set(['Reservations', 'No Show']),
  },
  {
    label: 'Automation',
    modules: new Set(['Enable Automation', 'Automation Scheduler', 'Instant Automation Pro']),
  },
  {
    label: 'Reports & Administration',
    modules: new Set([
      'Error Codes', 'Access Setup', 'Reports', 'Europcars', 'Fetch Console', 'Event Log',
      'Bank Reconciliation Report', 'Commission Screen', 'Support Screen', 'Reservation Insights',
      'DBR CleanUp', 'Review Screen', 'Automation Report', 'Partner Report',
    ]),
  },
];

export const getMenuSection = (moduleName) => (
  menuSectionDefinitions.find((section) => section.modules.has(moduleName))?.label
  || 'Other Tools'
);

export const getModuleRoute = (moduleName) => {
  if (moduleName === 'Dashboard') {
    return '/';
  }

  return `/${moduleName.toString().trim().replace(/\s+/g, '')}`;
};

export const normalizeNavigationPath = (pathname = '/') => {
  const pathWithoutQuery = pathname.split(/[?#]/, 1)[0] || '/';
  const normalizedPath = pathWithoutQuery.length > 1
    ? pathWithoutQuery.replace(/\/+$/, '')
    : pathWithoutQuery;

  return normalizedPath.toLowerCase();
};

const configuredRouteMetadata = menuSectionDefinitions.flatMap((section) => (
  [...section.modules].map((name) => ({
    name,
    section: section.label,
    routing: getModuleRoute(name),
  }))
));

configuredRouteMetadata.push({
  name: 'My Profile',
  section: 'Account',
  routing: '/MyProfile',
});

const humanizeRouteSegment = (pathname) => {
  const lastSegment = pathname.split('/').filter(Boolean).pop();

  if (!lastSegment) {
    return 'Dashboard';
  }

  let decodedSegment = lastSegment;
  try {
    decodedSegment = decodeURIComponent(lastSegment);
  } catch (error) {
    // Keep the original route segment when a malformed URL cannot be decoded.
  }

  return decodedSegment
    .replace(/[-_]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getRouteContext = (pathname) => {
  const normalizedPath = normalizeNavigationPath(pathname);
  const configuredRoute = configuredRouteMetadata.find(
    (item) => normalizeNavigationPath(item.routing) === normalizedPath
  );

  if (configuredRoute) {
    return configuredRoute;
  }

  return {
    name: humanizeRouteSegment(pathname),
    section: 'Workspace',
    routing: pathname,
  };
};
